import { useState } from "react";
import { toast } from "sonner";
import { Banknote } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { api, formatError } from "@/lib/api";

export const CashPaidDialog = ({ donation, onDone }) => {
  const [open, setOpen] = useState(false);
  const [amount, setAmount] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const { data } = await api.post(`/admin/donations/${donation.id}/mark-paid-cash`, { amount: Number(amount) });
      toast.success(data.message);
      setOpen(false);
      onDone();
    } catch (err) {
      setError(formatError(err));
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button className="flex items-center gap-1 whitespace-nowrap rounded-full border border-neutral-600 px-2.5 py-1 text-xs font-semibold text-neutral-300 transition-colors hover:bg-neutral-800" data-testid={`cash-paid-donation-${donation.id}`}>
          <Banknote className="h-3.5 w-3.5" /> Mark paid (cash)
        </button>
      </DialogTrigger>
      <DialogContent className="border-neutral-800 bg-neutral-950">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-gold">Mark paid — cash only</DialogTitle>
          <DialogDescription>
            Use this only when {donation.name} paid in cash. Stripe payments are confirmed automatically by the Stripe webhook.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4" data-testid="cash-paid-form">
          <Input type="number" step="0.01" min="0.01" required value={amount} onChange={(e) => setAmount(e.target.value)} placeholder="Cash amount (USD)" className="border-neutral-800 bg-neutral-900" data-testid="cash-paid-amount-input" />
          <p className="text-xs text-neutral-500">$5 or more adds the household's giveaway entry (one per household).</p>
          {error && <p className="text-sm text-red-400" data-testid="cash-paid-error">{error}</p>}
          <button type="submit" className="h-11 w-full rounded-full bg-amber-500 font-display font-semibold text-neutral-950" data-testid="cash-paid-submit">Confirm cash payment</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
